import { toast } from "react-toastify";

class Utils {
  isStandalone = () => {
    return window.matchMedia("(display-mode: standalone)").matches;
  };
  putCommas = (number) => {
    if (!number) return number;
    if (typeof number === "undefined") return number;
    if (typeof number === "number") number = number.toString();
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, "،");
  };
  createRange = (start, end) => {
    return Array(end - start + 1)
      .fill()
      .map((_, index) => start + index);
  };
  toEnglishDigits = (str) => {
    // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
    var e = "۰".charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function (t) {
      return t.charCodeAt(0) - e;
    });
    // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
    e = "٠".charCodeAt(0);
    str = str.replace(/[٠-٩]/g, function (t) {
      return t.charCodeAt(0) - e;
    });
    return str;
  };
  hasNumber = (term) => {
    return /\d/.test(term);
  };
  parseDigit(str = "") {
    var faNum = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return String(str).replace(/[0-9]/g, function (w) {
      return faNum[+w];
    });
  }
  lockScroll = () => {
    document.body.style.overflowY = "hidden";
    document.documentElement.style.overflowY = "hidden";
    document.body.addEventListener("touchmove", this.preventDefault, {
      passive: false,
    });
  };
  enableScroll = () => {
    document.body.style.overflowY = "auto";
    document.documentElement.style.overflowY = "auto";
    document.body.removeEventListener("touchmove", this.preventDefault);
  };
  preventDefault(e) {
    e.preventDefault();
  }
  setCookie(name, value, days = 30) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }
  getCookie(name, cookie) {
    name += "=";
    const decodedCookie = decodeURIComponent(cookie).split(";");
    for (let i = 0; i < decodedCookie.length; i++) {
      let c = decodedCookie[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  chunkArray(arr, chunk_size) {
    let result = [];
    for (let index = 0; index < arr.length; index += chunk_size) {
      const myChunk = arr.slice(index, index + chunk_size);
      result.push(myChunk);
    }
    return result;
  }
  etcString(str = "", count = 10) {
    return str && str !== null
      ? str.length < count
        ? str
        : str.slice(0, count - 2) + "..."
      : null;
  }
  isServer() {
    return !(typeof window != "undefined" && window.document);
  }
  cloneObj(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
  // async optimizeImage(file) {
  //   if (!file) return "NO";
  //   const { default: imageCompression } = await import(
  //     "browser-image-compression"
  //   );
  //   const res = await imageCompression(file, {
  //     maxSizeMB: 5,
  //     maxWidthOrHeight: 1920,
  //     useWebWorker: true,
  //   });
  //   return res;
  // }
  showAlert(str = "", type = "error", options = {}) {
    return toast(str, {
      type,
      ...options,
    });
  }
}

const utils = new Utils();
export default utils;
